import { type InputHTMLAttributes, useState } from 'react'
import { cn, formatRubles, type Kopecks, parseRubles } from '@/shared/lib'

// Ввод суммы в рублях, наружу отдаёт копейки. Хранение — копейки, показ — рубли
// табличным mono. Нормализует разряды на blur.

interface MoneyInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  value: Kopecks | null
  onChange: (kopecks: Kopecks | null) => void
  /** Компактная инлайн-форма (шапка проекта): узкий контрол по размеру значения. */
  compact?: boolean
}

export function MoneyInput({
  value,
  onChange,
  className,
  disabled,
  compact,
  ...rest
}: MoneyInputProps) {
  const [text, setText] = useState(() => (value == null ? '' : formatRubles(value)))

  return (
    <div
      className={cn(
        'items-center rounded-control bg-bg-sunken ring-inset focus-within:ring-border-accent',
        compact
          ? '-my-0.5 inline-flex gap-1 px-2 py-0.5 text-base ring-1 ring-border-accent'
          : 'flex gap-1.5 px-3 py-2.5 text-sm ring-1 ring-border-default',
        disabled && 'opacity-40',
        className,
      )}
    >
      <span className="mono-num shrink-0 text-text-tertiary">₽</span>
      <input
        {...rest}
        type="text"
        inputMode="decimal"
        disabled={disabled}
        value={text}
        onChange={(e) => {
          setText(e.target.value)
          onChange(parseRubles(e.target.value))
        }}
        onBlur={(e) => {
          const kopecks = parseRubles(e.target.value)
          setText(kopecks == null ? '' : formatRubles(kopecks))
          rest.onBlur?.(e)
        }}
        className={cn(
          'mono-num bg-transparent text-text-primary outline-none placeholder:text-text-tertiary',
          compact ? 'w-24' : 'w-full',
        )}
      />
    </div>
  )
}
